export default __webpack_public_path__ + "static/media/product-person.836fa952.svg";